import EasyTrans from "./EasyTrans";
import React from "react";
import { CodeIcon } from "@heroicons/react/outline";

const REPO_URL = "https://git.fairkom.net/hosting/faircommons";
// served from public/ (the Inkscape SVG has namespace tags SVGR can't import)
const FAIRKOM_LOGO = process.env.PUBLIC_URL + "/fairkom_logo.svg";

const LINKS = [
  { href: "https://www.fairkom.eu/about", label: "Footer.FooterAboutUs" },
  { href: "https://www.fairkom.eu/privacy", label: "Footer.FooterDataPrivacy" },
  { href: "https://www.fairkom.eu/imprint", label: "Footer.FooterImprint" },
  { href: "https://www.fairkom.eu/contact", label: "Footer.FooterContact" },
];

const Footer = () => {
  return (
    <footer className="bg-fairgray border-t border-gray-200 text-gray-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div>
            <img src={FAIRKOM_LOGO} alt="fairkom" className="h-10 w-auto" />
            <p className="mt-3 max-w-xs text-sm text-gray-500">
              Register and prove the authorship of your creative works — the
              relaunch of Registered Commons.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-2">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                target="_blank"
                rel="noreferrer"
                className="text-sm font-medium text-gray-600 transition-colors hover:text-fairdarkgreen"
              >
                <EasyTrans>{l.label}</EasyTrans>
              </a>
            ))}
            <a
              href={REPO_URL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-600 transition-colors hover:text-fairdarkgreen"
            >
              <CodeIcon className="h-4 w-4" aria-hidden="true" />
              Source code
            </a>
          </nav>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-gray-200 pt-6 text-sm text-gray-500 sm:flex-row sm:items-center sm:justify-between">
          <span>
            <EasyTrans>Footer.FooterAProjectBy</EasyTrans>&nbsp;
            <a
              href="https://www.fairkom.eu/"
              target="_blank"
              rel="noreferrer"
              className="font-medium text-fairdarkgreen hover:underline"
            >
              fairkom
            </a>
          </span>
          <span>© fairkom</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
